import { boards } from '@/socket'
export default {
  mounted () {
    boards.on('new', (data) => {
      this.$store.commit('freeBoard/SET_NEW_BOARD', data)
    })
  }
}
